module.exports = __webpack_public_path__ + "img/item-4(1920).b529f71b.jpg";